export default "__VITE_ASSET__Mkz$RI1H__"